import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { updateCommodityAction } from "../../../../../modules/commodities/action";
import "../../../../../style";
import { validForm } from "../../../../FormElement/FormValidator";
import CommodityForm from "./CommodityForm";



class EditCommodity extends Component {
  state = {
    commodityInfo: {
      name: "",
      lbsPerBushel: ""
    },
    formErrors: {
      name: "",
      lbsPerBushel: ""
    },
    isValid: true,
    successMessage: false,
    errorMessage: {}
  };

  componentWillMount() {
    const { id, name, lbsPerBushel } = this.props.selectedComm;
    this.setState({
      commodityInfo: {
        id,
        name,
        lbsPerBushel
      }
    });
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      prevState => {
        return {
          commodityInfo: {
            ...prevState.commodityInfo,
            [name]: value
          }
        };
      },
      () => {
        const { commodityInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, commodityInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.commUpdated && nextProps.commUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  updateCommodity = e => {
    e.preventDefault();
    const { commodityInfo, isValid } = this.state;
    if (!isValid) {
      this.props.updateCommodityAction(commodityInfo);
    }
  };

  render() {
    const { successMessage, isValid, commodityInfo } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/commodities" />;
    }
    return (
      <CommodityForm
        buttonLabel="Update"
        formLabel="Edit commodity"
        commodityInfo={commodityInfo}
        handleChange={this.handleChange}
        //handleError={this.handleError}
        createCommodity={this.updateCommodity}
        isValid={isValid}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedComm: state.commodityReducer.selectedComm,
    commUpdated: state.commodityReducer.commUpdated
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateCommodityAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditCommodity);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/Commodities/EditCommodity.js